import { ALL_CHART_TYPES, ALL_PRODUCT_TYPES } from "constants/chart.constants";

const ONTIME_OR_SHRINKAGE = [
  ALL_PRODUCT_TYPES.OnTime.label,
  ALL_PRODUCT_TYPES.Shrinkage.label,
  ALL_PRODUCT_TYPES.OnTime.key,
  ALL_PRODUCT_TYPES.Shrinkage.key
];
const PRESSURE_TYPES = [
  ALL_PRODUCT_TYPES.CasingPressure.label,
  ALL_PRODUCT_TYPES.TubingPressure.label,
  ALL_PRODUCT_TYPES.CasingPressure.key,
  ALL_PRODUCT_TYPES.TubingPressure.key
];

// TODO chart: switch chartType over to using EvaChart for MPC, consolidate products and chart types
export const isProductCompatibleWithChartType = (
  chartType: string,
  product: string
): boolean => {
  if (!ONTIME_OR_SHRINKAGE.includes(product) && !PRESSURE_TYPES.includes(product)) {
    return true;
  }
  if (
    [
      "monthlyRateTime",
      "rateDate",
      ALL_CHART_TYPES.RateTime.label,
      ALL_CHART_TYPES.RateDate.label
    ].includes(chartType) &&
    ONTIME_OR_SHRINKAGE.includes(product)
  ) {
    return true;
  }
  // Total Rate Cum is excluded on purpose: its decline has no pressure binding for the cum x-axis.
  if (
    [
      "monthlyRateCum",
      "monthlyRateTime",
      ALL_CHART_TYPES.RateCum.label,
      ALL_CHART_TYPES.RateTime.label
    ].includes(chartType) &&
    PRESSURE_TYPES.includes(product)
  ) {
    return true;
  }
  return false;
};
